var _style, _circle, _ellipse, _ellipse2, _ellipse3, _circle2, _circle3, _circle4, _circle5, _g, _g2, _circle6, _circle7, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCssc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#F9A037;stroke-width:5.5;stroke-miterlimit:10;}\n\t.st2{fill:#F9A037;}\n\t.st3{stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#000000;stroke-width:2.914;stroke-miterlimit:10;}\n\t.st6{fill:#077F40;}\n\t.st7{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 298.2,
    cy: 303.9,
    r: 270.9
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 298.4,
    cy: 303.5,
    rx: 45.1,
    ry: 131.4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5 -0.866 0.866 0.5 -113.65 410.2223)",
    className: "st1",
    cx: 298.4,
    cy: 303.5,
    rx: 45.1,
    ry: 131.4
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.866 -0.5 0.5 0.866 -111.7843 189.8849)",
    className: "st1",
    cx: 298.4,
    cy: 303.5,
    rx: 131.4,
    ry: 45.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 212.6,
    cy: 226.9,
    r: 15.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 222.2,
    cy: 379.5,
    r: 15.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 320,
    cy: 417.7,
    r: 15.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 381.5,
    cy: 226.9,
    r: 15.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M113.4,233.8c-0.8,2.3-2.2,4-4.2,4.9c-2.3,1.1-4.8,1.2-7.5,0.3c-5.4-1.8-7.8-6.4-6.1-11.5 c0.7-1.9,1.9-3.9,3.7-5.9l4,1.3l-0.4,1.3c-3.1-0.4-5,0.8-6,3.9c-1.2,3.7,0.7,6.5,5.8,8.2c5.1,1.7,8.4,0.7,9.6-3 c0.9-2.6,0.2-4.7-2-6.2l0.7-2.1C113.8,227.2,114.7,230.2,113.4,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.9,211.5c-2.5,0.8-4.9,0.5-7.5-0.9c-2.6-1.3-4.2-3.2-5-5.6c-0.7-2.2-0.4-4.3,0.7-6.6 c2.4-4.7,7.4-6.1,12.5-3.5c2.6,1.3,4.2,3.2,5,5.6c0.7,2.2,0.4,4.3-0.7,6.6C123.7,209.4,122,210.9,119.9,211.5z M119.2,197.5 c-4.8-2.5-8.2-1.9-10,1.6c-1.8,3.5-0.3,6.6,4.4,9.1c4.8,2.5,8.2,1.9,10-1.6C125.5,203.1,124,200,119.2,197.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.1,188l1.4-1.9l-12.7-9.1l-1.4,1.9l-1.1-0.8l4.2-5.8l1.1,0.8l-1.4,1.9l12.5,9l4.9-6.8l-2.5-1.8l0.9-1.2 l3.7,2.7l-8.5,11.9L134.1,188z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.8,166.3l1.6-1.7l-11.3-10.8l-1.6,1.7l-0.9-0.9l4.9-5.2l0.9,0.9l-1.6,1.7l11.2,10.6l5.7-6l-2.2-2.1l1-1.1 l3.3,3.1l-10.1,10.6L150.8,166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.4,147l1.8-1.4l-9.7-12.3l-1.8,1.4l-0.8-1l11.5-9.1l2.5,3.2l-1.2,0.9l-1.6-2l-6.6,5.2l3.8,4.8l4.7-3.7 l-1.4-1.8l1.2-0.9l3.7,4.8l-1.2,0.9l-1.4-1.8l-4.7,3.7l4.7,6l6.7-5.3l-1.6-2l1.2-0.9l2.5,3.2l-11.7,9.2L170.4,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.9,112c-3.6,2.1-4.1,5.5-1.4,10.2c2.7,4.7,5.9,6,9.5,3.9c1.6-0.9,2.8-2.1,3.7-3.7l-2.3-4.1l-3,1.7 l-0.6-1.1l5.1-2.9l3.4,5.9c-1.2,2.2-3.1,3.9-5.6,5.4c-4.8,2.7-9.8,1.3-12.6-3.7c-2.8-5-1.6-10,3.3-12.8c1.9-1.1,4-1.7,6.6-2.1 l2.2,3.8l-1.2,0.7C197.9,110.7,195.7,110.4,192.9,112z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M219.6,116.3l2.2-0.8l-5.7-14.6l-2.2,0.8l-0.5-1.2l13.7-5.3l1.5,3.8l-1.4,0.5l-0.9-2.4l-7.8,3l2.2,5.7 l5.6-2.2l-0.8-2.1l1.4-0.5l2.2,5.6l-1.4,0.5l-0.8-2.1l-5.6,2.2l2.8,7.1l8-3.1l-0.9-2.4l1.4-0.5l1.5,3.8l-13.9,5.4L219.6,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.6,101.6c-2-1.6-3.2-3.7-3.5-6.7c-0.4-2.9,0.2-5.3,1.8-7.3c1.4-1.8,3.3-2.8,5.8-3.1 c5.2-0.6,9.2,2.6,9.9,8.3c0.4,2.9-0.2,5.3-1.8,7.3c-1.4,1.8-3.3,2.8-5.8,3.1C271.5,103.6,269.3,103,267.6,101.6z M278.8,93.1 c-0.7-5.4-3.1-7.8-7-7.3s-5.7,3.5-5,8.8s3.1,7.8,7,7.3C277.8,101.5,279.5,98.5,278.8,93.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295,100l2.3,0l0.3-15.6l-2.3,0l0-1.3l14.9,0.3l-0.1,4l-1.5,0l0.1-2.5l-8.6-0.2l-0.1,6.1l6.2,0.1l0-2.3l1.5,0 l-0.1,6l-1.5,0l0-2.3l-6.2-0.1l-0.2,7.8l2.9,0.1l0,1.3l-7.7-0.2L295,100z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M343.1,101.3l1.4,0.4c-0.6,2.7,0.5,4.3,3.5,5.1c2.8,0.7,4.6,0,5.2-2.1c0.5-2-0.4-2.8-2.6-4.2l-2.1-1.3 c-3-1.8-4-3.5-3.3-6.3c0.8-3,3.4-4.1,7.3-3.1c1.6,0.4,3.5,1.3,5.5,2.6l-1,3.7l-1.3-0.3c0.4-2.6-0.7-4-3.5-4.7 c-2.5-0.7-4.1,0-4.6,2c-0.5,2.1,0.6,3,3,4.4l2,1.2c2.8,1.7,3.9,3.4,3.2,6c-0.9,3.4-3.5,4.6-7.9,3.4c-2-0.5-3.9-1.5-5.7-2.8 L343.1,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M374.7,117.3c-2.2-0.9-3.8-2.5-4.6-4.6c-1-2.4-0.9-4.9,0.3-7.5c2.2-5.2,7-7.3,11.9-5.2 c1.9,0.8,3.7,2.2,5.6,4.1l-1.6,3.9l-1.3-0.5c0.6-3.1-0.4-5-3.4-6.3c-3.6-1.5-6.5,0.2-8.6,5.2c-2.1,5-1.3,8.3,2.3,9.8 c2.5,1.1,4.6,0.5,6.3-1.5l2.1,0.9C381.3,118.2,378.3,118.8,374.7,117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M400,128.4l-0.7,1.1l-6.2-3.6l0.7-1.1l2,1.2l7.8-13.5l-2-1.2l0.7-1.1l6.2,3.6l-0.7,1.1l-2-1.2l-7.8,13.5 L400,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M411.2,135.5l1.9,1.4l9.5-12.4l-1.9-1.4l0.8-1l11.7,8.9l-2.5,3.2l-1.2-0.9l1.5-2l-6.7-5.1l-3.7,4.9l4.8,3.6 l1.4-1.8l1.2,0.9l-3.7,4.8l-1.2-0.9l1.4-1.8l-4.8-3.6l-4.6,6.1l6.8,5.2l1.5-2l1.2,0.9l-2.5,3.2l-11.8-9L411.2,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M433.2,153.3l1.7,1.8l11.2-10.9l-1.7-1.8l0.9-0.9l3.2,3.4l-2.8,17.8l9.4-9.1l-1.7-1.8l0.9-0.9l4.4,4.6 l-0.9,0.9l-1.7-1.8l-12.4,12l-1-1.1l2.9-19.1l-9.9,9.5l1.7,1.8l-0.9,0.9l-4.4-4.6L433.2,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M458.1,184.9c-1.4-2-1.9-4.1-1.5-6.3c0.4-2.5,1.8-4.6,4.2-6.3c4.6-3.3,9.8-2.5,12.9,1.8 c1.2,1.7,2,3.8,2.6,6.5l-3.4,2.4l-0.8-1.1c2.2-2.3,2.3-4.5,0.4-7.2c-2.2-3.2-5.7-3.2-10.1-0.1s-5.5,6.4-3.2,9.5 c1.6,2.2,3.6,2.9,6.2,2l1.3,1.8C463.3,189.1,460.4,188.1,458.1,184.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M470.5,201.2l1.1,2.1l13.9-7.1l-1.1-2.1l1.2-0.6l6.6,13.1l-3.6,1.8l-0.7-1.3l2.3-1.2l-3.8-7.5l-5.4,2.8 l2.7,5.3l2-1l0.7,1.3l-5.4,2.7l-0.7-1.3l2-1l-2.7-5.3l-6.8,3.4l3.9,7.6l2.3-1.2l0.7,1.3l-3.6,1.8l-6.7-13.3L470.5,201.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M486.2,226.5l0.5,1.3c-2.6,1-3.4,2.8-2.4,5.7c0.9,2.8,2.6,3.8,4.6,3.1c1.9-0.7,2.1-1.9,2.1-4.5l-0.1-2.5 c-0.1-3.5,0.7-5.3,3.4-6.2c2.9-1,5.3,0.6,6.6,4.4c0.5,1.6,0.9,3.6,0.9,6l-3.7,1.2l-0.4-1.3c2.4-1.1,2.9-2.8,2-5.5 c-0.8-2.4-2.3-3.4-4.2-2.7c-2,0.7-2.2,2.2-2.1,4.9l0.1,2.3c0.1,3.3-0.7,5.1-3.3,6c-3.3,1.1-5.8-0.4-7.2-4.7 c-0.7-1.9-0.9-4-0.8-6.3L486.2,226.5z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.2,393.5l0.6,1.3c-2.4,1.2-2.9,3.1-1.6,5.9c1.2,2.7,2.9,3.6,4.9,2.7c1.8-0.8,1.9-2.1,1.5-4.7l-0.4-2.5 c-0.5-3.5,0.1-5.3,2.6-6.5c2.7-1.2,5.3,0.1,6.9,3.8c0.7,1.5,1.2,3.5,1.6,5.9l-3.4,1.6l-0.6-1.3c2.2-1.3,2.5-3,1.3-5.7 c-1.1-2.4-2.6-3.2-4.4-2.4c-1.9,0.9-1.9,2.4-1.4,5.1l0.3,2.3c0.5,3.3-0.1,5.2-2.5,6.2c-3.1,1.4-5.7,0.1-7.5-4 c-0.9-1.9-1.4-4-1.5-6.2L105.2,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.8,426.7l1.3,1.9l12.5-8.4l-3-4.5l-2.3,1.6l-0.8-1.3l3.5-2.3l9.2,13.5l-3.5,2.3l-0.8-1.3l2.3-1.6l-3-4.5 l-12.5,8.4l1.3,1.9l-1,0.7l-4-6L118.8,426.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.9,440.4l0.9-0.9l5,5.2l-0.9,0.9l-1.6-1.7l-6.6,6.4c-3.1,3-3.5,5.1-0.8,7.9c2.7,2.8,4.8,2.5,7.9-0.6 l6.6-6.4l-1.6-1.7l0.9-0.9l4.3,4.5l-0.9,0.9l-1.6-1.7l-6.7,6.5c-3.8,3.7-6.5,3.9-10.2,0.1c-3.7-3.8-3.5-6.6,0.3-10.3l6.7-6.5 L147.9,440.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.8,477l1.9,1.4l8.9-12.3l-1.9-1.4l0.7-1l6,4.3c5.2,3.7,6.3,8.6,3,13.1s-8.2,5-13.4,1.3l-6-4.3L164.8,477z  M170.6,481.2c3.9,2.8,7.6,2.1,10.5-1.9c2.9-4,2.3-7.7-1.6-10.5l-1.9-1.3l-8.9,12.3L170.6,481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M194.7,496.5l2.1,1l6.7-13.6l-2.1-1l0.6-1.1l13.3,6.6l-1.7,3.5l-1.4-0.7l1.1-2.2l-7.6-3.7l-2.6,5.3l5.4,2.7 l1-2l1.4,0.7l-2.6,5.3l-1.4-0.7l1-2l-5.4-2.7l-3.3,6.6l7.8,3.8l1.1-2.2l1.4,0.7l-1.7,3.5l-13.5-6.7L194.7,496.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M226.2,510.5l2.4,0.7l4.3-14.6l-2.4-0.7l0.4-1.2l4.5,1.3l6.6,16.5l3.6-12.2l-2.4-0.7l0.4-1.2l6.2,1.8 l-0.4,1.2l-2.4-0.7l-4.8,16.1l-1.4-0.4l-7-17.7l-3.8,12.8l2.4,0.7l-0.4,1.2l-6.2-1.8L226.2,510.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M267.8,520.3l2.3,0.3l1.8-14.9l-5.4-0.7l-0.3,2.8l-1.5-0.2l0.5-4.1l16.2,2l-0.5,4.1l-1.5-0.2l0.3-2.8 l-5.4-0.7l-1.8,14.9l2.3,0.3l-0.2,1.3l-7.1-0.9L267.8,520.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.2,521.7c-2.4,0.3-4.6-0.2-6.4-1.5c-2.1-1.5-3.3-3.6-3.7-6.4c-0.8-5.5,2.3-9.6,7.6-10.4 c2.1-0.3,4.4-0.1,7,0.5l0.6,4l-1.4,0.2c-1-2.9-3-4-6.2-3.5c-3.9,0.6-5.5,3.5-4.8,8.7c0.7,5.2,3.2,7.6,7,7c2.7-0.4,4.3-1.9,4.7-4.5 l2.3-0.3C336.4,519,334.1,521.1,330.2,521.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M358.3,513.4c-2.3-1.1-3.8-3-4.7-5.7c-0.9-2.7-0.7-5.1,0.5-7.4c1.1-2,2.8-3.3,5.2-4.1 c5.1-1.6,9.6,0.8,11.3,6.1c0.9,2.7,0.7,5.1-0.5,7.4c-1.1,2-2.8,3.3-5.2,4.1C362.6,514.5,360.3,514.3,358.3,513.4z M368,503.1 c-1.6-5-4.4-6.9-8.2-5.7c-3.8,1.2-5,4.4-3.4,9.4c1.6,5,4.4,6.9,8.2,5.7C368.4,511.3,369.6,508.1,368,503.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M382.8,489.1l-0.6-1.1l6.4-3.3l0.6,1.1l-2.1,1.1l4.2,8.1c2,3.8,3.8,4.9,7.3,3c3.5-1.8,3.8-3.9,1.8-7.7 l-4.2-8.1l-2.1,1.1l-0.6-1.1l5.5-2.8l0.6,1.1l-2.1,1.1l4.3,8.4c2.4,4.7,1.8,7.4-2.9,9.8c-4.7,2.4-7.4,1.4-9.8-3.3l-4.3-8.4 L382.8,489.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M422.7,483.7l2-1.5l-9.3-12l-2,1.5l-0.8-1l3.7-2.9l17.3,4.3l-7.8-10.1l-2,1.5l-0.8-1l5.1-3.9l0.8,1l-2,1.5 l10.3,13.3l-1.2,0.9l-18.5-4.6l8.1,10.5l2-1.5l0.8,1l-5.1,3.9L422.7,483.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M458.8,453.8c-1.6,1.8-3.6,2.8-5.8,2.9c-2.6,0.2-4.8-0.7-6.9-2.6c-4.1-3.7-4.3-8.9-0.7-12.9 c1.4-1.5,3.3-2.8,5.8-4l3,2.8l-0.9,1c-2.6-1.6-4.8-1.2-7,1.3c-2.6,2.9-2,6.2,1.8,9.8s7.2,3.8,9.9,0.9c1.8-2,2.1-4.2,0.8-6.5 l1.5-1.7C461.9,447.8,461.4,450.9,458.8,453.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M478.1,426.2l1,0.7l-4,6l-1-0.7l1.3-2l-12.6-8.5l-1.3,2l-1-0.7l4-6l1,0.7l-1.3,2l12.6,8.5L478.1,426.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M487.7,409.9l1-2.1l-13.7-6.5l-1,2.1l-1.1-0.5l3.1-6.5l1.1,0.5l-1,2.1l13.5,6.4l3.6-7.6l-2.7-1.3l0.7-1.4 l4,1.9l-6.4,13.3L487.7,409.9z"
  })))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 298.2,
    cy: 303.9,
    r: 243.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 298.2,
    cy: 303.9,
    r: 175.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.2,252.4H32.3c-3.2,16.7-4.9,33.9-4.9,51.5s1.7,34.9,4.9,51.5h531.9c3.2-16.7,4.9-33.9,4.9-51.5 S567.4,269.1,564.2,252.4z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M55,312.1h3.9c1.2,7,5.6,10.3,13.5,10.3c6.5,0,9.8-2.5,9.8-7.1c0-4.6-3.1-5.8-8.7-7.2l-6.9-1.7 c-8.5-2.2-12.3-5.6-12.3-13.5c0-9.2,6.4-14.5,17.3-14.5c5.3,0,11.1,0.9,17.5,2.7v10.2h-3.9c-1.2-6.4-5.1-9.2-12.5-9.2 c-6.1,0-9.2,2.2-9.2,6.3c0,4.9,3.2,5.9,9.5,7.5l6.9,1.7c8.4,2.1,12.2,6.3,12.2,14.4c0,9.3-6.5,14.2-19,14.2c-6,0-11.9-1-18-3.1 V312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M109,321.5h5.9v-38.7H109v-3.7h23.7c16.6,0,25.6,8.2,25.6,23c0,14.9-9,23.1-25.6,23.1H109V321.5z M131.1,321.5 c9.8,0,13.9-6.1,13.9-19.4s-4.1-19.3-13.9-19.3h-4.3v38.7H131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M176,312.1h3.9c1.2,7,5.6,10.3,13.5,10.3c6.5,0,9.8-2.5,9.8-7.1c0-4.6-3.1-5.8-8.7-7.2l-6.9-1.7 c-8.5-2.2-12.3-5.6-12.3-13.5c0-9.2,6.4-14.5,17.3-14.5c5.3,0,11.1,0.9,17.5,2.7v10.2h-3.9c-1.2-6.4-5.1-9.2-12.5-9.2 c-6.1,0-9.2,2.2-9.2,6.3c0,4.9,3.2,5.9,9.5,7.5l6.9,1.7c8.4,2.1,12.2,6.3,12.2,14.4c0,9.3-6.5,14.2-19,14.2c-6,0-11.9-1-18-3.1 V312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.2,282.9v-3.7h23.7v3.7H247V306c0,11,2.8,15.5,11.9,15.5c8.9,0,11.7-4.6,11.7-15.5v-23.1h-5.9v-3.7h16.1 v3.7h-5.9v23.7c0,14.1-5.6,19.5-19.9,19.5c-14.3,0-19.9-5.6-19.9-19.6v-23.7H229.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M352.6,326.2c-15.6,0-25.2-9.2-25.2-23.9s9.6-23.9,25.2-23.9c5.7,0,11.6,1.4,18,4v11.3h-3.9 c-1.6-7.7-5.8-11.6-12.8-11.6c-9,0-13.3,6.6-13.3,20.2c0,13.7,4.2,20.2,13.3,20.2c6.1,0,10-3.4,11.8-10.3h6.1 C369.4,321.6,363.2,326.2,352.6,326.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M390.2,312.1h3.9c1.2,7,5.6,10.3,13.5,10.3c6.5,0,9.8-2.5,9.8-7.1c0-4.6-3.1-5.8-8.7-7.2l-6.9-1.7 c-8.5-2.2-12.3-5.6-12.3-13.5c0-9.2,6.4-14.5,17.3-14.5c5.3,0,11.1,0.9,17.5,2.7v10.2h-3.9c-1.2-6.4-5.1-9.2-12.5-9.2 c-6.1,0-9.2,2.2-9.2,6.3c0,4.9,3.2,5.9,9.5,7.5l6.9,1.7c8.4,2.1,12.2,6.3,12.2,14.4c0,9.3-6.5,14.2-19,14.2c-6,0-11.9-1-18-3.1 V312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M444.7,312.1h3.9c1.2,7,5.6,10.3,13.5,10.3c6.5,0,9.8-2.5,9.8-7.1c0-4.6-3.1-5.8-8.7-7.2l-6.9-1.7 c-8.5-2.2-12.3-5.6-12.3-13.5c0-9.2,6.4-14.5,17.3-14.5c5.3,0,11.1,0.9,17.5,2.7v10.2h-3.9c-1.2-6.4-5.1-9.2-12.5-9.2 c-6.1,0-9.2,2.2-9.2,6.3c0,4.9,3.2,5.9,9.5,7.5l6.9,1.7c8.4,2.1,12.2,6.3,12.2,14.4c0,9.3-6.5,14.2-19,14.2c-6,0-11.9-1-18-3.1 V312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M523.6,326.2c-15.6,0-25.2-9.2-25.2-23.9s9.6-23.9,25.2-23.9c5.7,0,11.6,1.4,18,4v11.3h-3.9 c-1.6-7.7-5.8-11.6-12.8-11.6c-9,0-13.3,6.6-13.3,20.2c0,13.7,4.2,20.2,13.3,20.2c6.1,0,10-3.4,11.8-10.3h6.1 C540.5,321.6,534.3,326.2,523.6,326.2z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M564.2,252.4H32.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M32.3,355.5h531.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssc);
export default __webpack_public_path__ + "static/media/cssc.13d48460ab01d087e79ca512a5f959b3.svg";
export { ForwardRef as ReactComponent };